<template>
<div>
    <v-progress-circular v-if="this.saving"
        indeterminate
        color="green"
      ></v-progress-circular>

    <v-row no-gutters class="pa-0" v-if="!raz5">
      <v-col cols="12" sm="12" md="12" xs="12" lg="10" xl="10">
        <v-autocomplete
          :items="raz5Items"
          v-model="raz5Selected"
          label="Odaberite razinu 5"
          single-line
          item-text="klasusRaz5"
          item-value="Razina5"
          return-object
          persistent-hint
          clearable
          dense
          outlined
          disabled
        ></v-autocomplete>
      </v-col>
    </v-row>
    <v-row no-gutters class="pa-0" v-if="raz5">
      <v-col cols="12" sm="12" md="12" xs="12" lg="10" xl="10">
        <v-autocomplete
          :items="raz5Items"
          v-model="raz5Selected"
          label="Odaberite razinu 5"
          single-line
          item-text="klasusRaz5"
          item-value="Razina5"
          return-object
          persistent-hint
          clearable
          dense
          outlined
        ></v-autocomplete>
      </v-col>
    </v-row>

   <KlasusLevel6 :raz1Selected="raz1Selected" :raz2Selected="raz2Selected" :raz3Selected="raz3Selected" :raz4Selected="raz4Selected" :raz5Selected="raz5Selected"/>
</div>
</template>

<script>


import KlasusService from '@/services/KlasusService'
import KlasusLevel6 from './KlasusLevel6.vue'
export default {
  name: 'klasuslevel5',
  props:['raz1Selected','raz2Selected','raz3Selected','raz4Selected'],
  data () {
    return {
      msg: '',
      saving: false,
      raz5: false,
      raz5Items: [],
      raz5Selected: {},
      razUpit: {}
    }
  },
  async mounted () {
    await this.findRaz5()
  },
  methods: {
    async findRaz5() {
      let trazi = false

      if (Object.keys(this.raz1Selected).length > 0 && Object.keys(this.raz2Selected).length > 0 && Object.keys(this.raz3Selected).length > 0 && Object.keys(this.raz4Selected).length > 0) {
        this.razUpit.Razina1 = this.raz1Selected.Razina1
        this.razUpit.Razina2 = this.raz2Selected.Razina2
        this.razUpit.Razina3 = this.raz3Selected.Razina3
        this.razUpit.Razina4 = this.raz4Selected.Razina4
        this.razUpit.onLevel = 5
        trazi = true
      }
      if (trazi) {
        console.log('Trazim na razini 5 ->', this.raz1Selected, this.raz2Selected, this.raz3Selected, this.raz4Selected)
        await KlasusService.choose(this.razUpit).then(res => {
          if (res.data.klasusData) {
            this.raz5Items = res.data.klasusData
            this.raz5 = true
            console.log('this.raz5Items', this.raz5Items)
          }
        })
        .catch(err => {
          this.havealert = !this.havealert
          this.havemssgalert = 'Error on init Klasus Raz 5 ' + err
        })
      }
    }

  },
  computed: {

  },
  watch: {
    'raz4Selected'() {
      if (this.raz4Selected) {
        this.findRaz5()
      }
      if (!this.raz4Selected) {
        console.log('sad ga nemam razina 5')
        this.raz5 = false
      }
    }
  },
  components: {
    KlasusLevel6
  }

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
